import { render, staticRenderFns } from "./buttonStastic.vue?vue&type=template&id=d9c0249a&scoped=true&"
import script from "./buttonStastic.vue?vue&type=script&lang=js&"
export * from "./buttonStastic.vue?vue&type=script&lang=js&"
import style0 from "./buttonStastic.vue?vue&type=style&index=0&id=d9c0249a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c0249a",
  null
  
)

export default component.exports